<span class="request-word-wrapper">
    <pre>
        {{ scan.contents.original }}
    </pre>
</span>

